'use client';

import { c } from 'ui-components';
import { SidebarSkeleton } from '../../Skeleton/SidebarSkeleton';
import { CategoryFacet } from '../CategoryFacet';
import { OwnershipFacet } from '../OwnershipFacet';
import { SaleFacet } from '../SaleFacet';
import { useSearchLoading } from '../useSearchLoading';
import { SidebarProps } from './Sidebar.types';

export const Sidebar = ({ className }: SidebarProps) => {
  const { isInitialLoad } = useSearchLoading();

  if (isInitialLoad) {
    return <SidebarSkeleton className={className} />;
  }

  return (
    <nav
      aria-label="Search filters"
      className={c('flex flex-col gap-6', className)}
    >
      <SaleFacet />
      <CategoryFacet />
      <OwnershipFacet />
    </nav>
  );
};
